module.exports = __webpack_public_path__ + "static/media/bfito.75cf59ba.png";